import Style from './style.module.css';

export const CollapsibleSection = ({
  id,
  title,
  children,
  openSections,
  toggleSection,
}) => {
  const isOpen = !!openSections[id];

  return (
    <div className={Style.sectionWrapper}>
      <div className={Style.sectionHeader} onClick={() => toggleSection(id)}>
        <h3 className={Style.sectionTitle}>{title}</h3>

        <div
          className={`${Style.sectionToggle} ${
            isOpen ? Style.sectionToggleOpen : ''
          }`}
        >
          ▾
        </div>
      </div>

      <div
        className={`${Style.sectionBody} ${
          isOpen ? Style.sectionBodyOpen : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
};
